export const OBJECT_TYPES = {
  GUILD: 'guild',
  PLAYER: 'player',
  PLANET: 'planet',
  REACTOR: 'reactor',
  SUBSTATION: 'substation',
  STRUCT: 'struct',
  ALLOCATION: 'allocation',
  INFUSION: 'infusion',
  ADDRESS: 'address',
  FLEET: 'fleet',
  PROVIDER: 'provider',
  AGREEMENT: 'agreement',
};

